export const AppConfig = {
    appTitle: 'CXA Group - Case Assignment Application',
    // tslint:disable-next-line
    flickrApiBase: 'https://api.flickr.com/services/rest/?method=flickr.photos.getRecent&api_key=12aaca691f3effb2e4ec52478e110197&format=json&nojsoncallback=1',
    toastrConfig: {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
        preventDuplicates: true,
    }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts